var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { ThemeBreakpoints } from '../theme/breakpoints';
var useWindowSize = function () {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var _a = useState({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    var theme = useContext(ThemeContext);
    var breakpoints = theme.breakpoints;
    var smallWidth = parseInt(breakpoints[ThemeBreakpoints.SMALL]);
    var mediumWidth = parseInt(breakpoints[ThemeBreakpoints.MEDIUM]);
    var largeWidth = parseInt(breakpoints[ThemeBreakpoints.LARGE]);
    var currentBreakpoint = ThemeBreakpoints.LARGE;
    if (windowSize.width < smallWidth) {
        currentBreakpoint = ThemeBreakpoints.MOBILE;
    }
    else if (windowSize.width < mediumWidth) {
        currentBreakpoint = ThemeBreakpoints.SMALL;
    }
    else if (windowSize.width < largeWidth) {
        currentBreakpoint = ThemeBreakpoints.MEDIUM;
    }
    useEffect(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return __assign(__assign({}, windowSize), { currentBreakpoint: currentBreakpoint });
};
export default useWindowSize;
